import { render } from "./AppReorderPhoto.vue?vue&type=template&id=0345930c&scoped=true&ts=true"
import script from "./AppReorderPhoto.vue?vue&type=script&lang=ts"
export * from "./AppReorderPhoto.vue?vue&type=script&lang=ts"

import "./AppReorderPhoto.vue?vue&type=style&index=0&id=0345930c&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0345930c"]])

export default __exports__